export { allFootballTeams as teamStats } from '@/mocks/estadisticas-football';
export { allBasketballTeams as basketballStats } from '@/mocks/estadisticas-basketball';
export { allTennisPlayers as tennisStats } from '@/mocks/estadisticas-tennis';
export type { FootballTeam } from '@/mocks/estadisticas-football';
export type { BasketballTeam } from '@/mocks/estadisticas-basketball';
export type { TennisPlayer } from '@/mocks/estadisticas-tennis';

export const sports = ["Fútbol", "Tenis", "Baloncesto"];

export type LeagueGroup = { group: string; leagues: string[] };

export const leagueGroupsBySport: Record<string, LeagueGroup[]> = {
  "Fútbol": [
    { group: "", leagues: ["Todas las ligas"] },
    { group: "Las 5 Grandes Ligas", leagues: ["LaLiga", "Premier League", "Serie A", "Bundesliga", "Ligue 1"] },
    { group: "Competiciones Europeas (Clubes)", leagues: ["Champions League", "Europa League", "Conference League"] },
    { group: "Selecciones", leagues: ["Mundial FIFA", "UEFA Euro", "Copa América", "Copa África", "Copa Asia"] },
  ],
  "Baloncesto": [
    { group: "", leagues: ["Todas las ligas"] },
    { group: "Ligas Principales", leagues: ["NBA", "EuroLeague", "Liga ACB", "Lega Basket", "Bundesliga Basket", "Pro A"] },
    { group: "Comp. Europeas (Clubes)", leagues: ["EuroCup"] },
    { group: "Selecciones", leagues: ["FIBA World Cup", "EuroBasket", "Copa América FIBA"] },
  ],
  "Tenis": [
    { group: "", leagues: ["Todos los torneos"] },
    { group: "Circuitos Principales", leagues: ["ATP Tour", "WTA Tour"] },
    { group: "Grand Slams", leagues: ["Australian Open", "Roland Garros", "Wimbledon", "US Open"] },
    { group: "Comp. por Equipos (Selecciones)", leagues: ["Copa Davis", "Copa Billie Jean King"] },
  ],
};

// Flat lists for backward compat
export const leaguesBySport: Record<string, string[]> = Object.fromEntries(
  Object.entries(leagueGroupsBySport).map(([sport, groups]) => [
    sport,
    groups.flatMap((g) => g.leagues),
  ])
);

export const statsFiltersBySport: Record<string, { id: string; label: string; icon: string }[]> = {
  "Fútbol": [
    { id: "corners",     label: "Corners",     icon: "ri-flag-line" },
    { id: "goals",       label: "Goles",       icon: "ri-football-line" },
    { id: "cards",       label: "Tarjetas",    icon: "ri-price-tag-3-line" },
    { id: "shots",       label: "Disparos",    icon: "ri-arrow-right-circle-line" },
    { id: "possession",  label: "Posesión",    icon: "ri-percent-line" },
    { id: "xg",          label: "xG",          icon: "ri-bubble-chart-line" },
  ],
  "Tenis": [
    { id: "serve",       label: "Servicio",    icon: "ri-navigation-line" },
    { id: "return",      label: "Resto / Win%",icon: "ri-refresh-line" },
    { id: "breakpoints", label: "Break Points",icon: "ri-flashlight-line" },
    { id: "aces",        label: "Aces",        icon: "ri-arrow-up-circle-line" },
    { id: "sets",        label: "Sets",        icon: "ri-bar-chart-line" },
  ],
  "Baloncesto": [
    { id: "scoring",     label: "Anotación",   icon: "ri-numbers-line" },
    { id: "rebounds",    label: "Rebotes",     icon: "ri-arrow-up-down-line" },
    { id: "assists",     label: "Asistencias", icon: "ri-team-line" },
    { id: "shooting",    label: "% Tiros",     icon: "ri-percent-line" },
    { id: "defense",     label: "Defensa",     icon: "ri-shield-line" },
  ],
};

export const statsFilters = statsFiltersBySport["Fútbol"];

export const advancedSearchFilters = [
  { id: "corners_over", label: "% partidos con más de X corners", type: "range",  values: ["4.5","5.5","6.5","7.5","8.5","9.5","10.5"] },
  { id: "period",       label: "Período del partido",             type: "select", values: ["Partido completo","Primera mitad","Segunda mitad"] },
  { id: "venue",        label: "Condición de campo",              type: "select", values: ["Todos","Local","Visitante"] },
  { id: "min_matches",  label: "Mínimo de partidos",              type: "select", values: ["5","10","15","20"] },
];
